import { createFileRoute } from '@tanstack/react-router';
import { PersonCardPage } from '../features/records/PersonCardPage';
import { validateCardSearch } from '../lib/cardSearch';

export const Route = createFileRoute('/people/$id')({
  validateSearch: validateCardSearch,
  component: function CardRoute() {
    const { id } = Route.useParams();
    return <PersonCardPage id={id} />;
  },
});
